import update from 'immutability-helper'

import {fuseNavigationConfig} from 'fuse-configs/fuseNavigationConfig'
import * as Actions from '../../actions/fuse/index'

const initialState = fuseNavigationConfig

const navigation = function reducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_NAVIGATION: {
      return [...state]
    }
    case Actions.SET_NAVIGATION: {
      return [...action.navigation]
    }
    case Actions.RESET_NAVIGATION: {
      return [...initialState]
    }
    case Actions.UPDATE_NAVIGATION_NOTIFICATION: {
      const {id, number} = action.payload
      const application = state[0]
      const indexOfChatPage = application.children.findIndex(c => c.id === id)
      const newBadge =
        number > 0
          ? {
              title: number,
              bg: '#F44336',
              fg: '#FFFFFF',
            }
          : undefined

      const newState = update(state, {
        0: {
          children: {
            [indexOfChatPage]: {
              badge: {
                $set: newBadge,
              },
            },
          },
        },
      })

      return [...newState]
    }
    default: {
      return state
    }
  }
}

export default navigation



// WEBPACK FOOTER //
// ./src/store/reducers/fuse/navigation.reducer.js